import boringmenu from './boringmenu.js';

window.boringmenu = boringmenu;
